import { Col, Row } from "antd"
import React from "react"

// Shared UI Components
export const SectionHeader = ({ title }: { title: string }) => <Row className="font-medium text-black text-[14px] bg-finway-green-light6 rounded-sm px-3 py-8">{title}</Row>

export const DataRow = ({ label, value, isAlternate = false }: { label: string; value: React.ReactNode; isAlternate?: boolean }) => (
    <Row justify="space-between" align="top" className={`p-6 ${isAlternate ? "bg-gray-100" : ""}`}>
        <Col span={12}>
            <span className="font-thin">{label}</span>
        </Col>
        <Col span={12}>
            <span className="text-black font-medium">{value}</span>
        </Col>
    </Row>
)

export const DataSection = ({ children }: { children: React.ReactNode }) => <div className="border-1 border-gray-200 rounded-sm text-xs">{children}</div>

export const SummaryRow = ({ label, value, isBold = false }: { label: string; value: React.ReactNode; isBold?: boolean }) => (
    <Row className="p-4 border-b-1 border-gray-200 text-xs">
        <Col span={12}>
            <span className={isBold ? "font-medium text-black" : "font-thin"}>{label}</span>
        </Col>
        <Col span={12} className="text-right font-medium text-black">
            <span>{value}</span>
        </Col>
    </Row>
)

export const TableHeader = ({ columns }: { columns: Array<{ span: number; label: string; textAlign?: string; offset?: number }> }) => (
    <Row className="text-xs font-thin">
        {columns.map((col, index) => (
            <Col key={index} span={col.span} offset={col.offset} className={col.textAlign === "right" ? "text-right" : ""}>
                <span>{col.label}</span>
            </Col>
        ))}
    </Row>
)
